module.exports = __webpack_public_path__ + "static/logo_full-f45820abfba1b1be210ce655800247c1.png";